import { Fragment, useEffect, useMemo } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import styles from './index.module.scss'
import DisplayText from '../../components/DisplayText';
import { getPostBySlug } from '../Blog/articles'

const FigureBlock = ({ src, alt, caption }) => (
  <figure className={styles.figureBlock}>
    <img src={src} alt={alt} />
    <figcaption style={{color: 'rgba(255,255,255,.6)'}}>{caption}</figcaption>
  </figure>
)

const scrollToPageTop = () => {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
}

const renderInlineText = (text) =>
  text.split(/(\*\*.*?\*\*|\[.*?\]\(.*?\))/g).map((part, index) => {
    const isBoldText = part.startsWith('**') && part.endsWith('**')
    const linkMatch = part.match(/^\[(.*?)\]\((.*?)\)$/)

    if (isBoldText) {
      return <strong key={`${part}-${index}`}>{part.slice(2, -2)}</strong>
    }

    if (linkMatch) {
      return (
        <a key={`${part}-${index}`} href={linkMatch[2]} target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>
          {linkMatch[1]}
        </a>
      )
    }

    return <Fragment key={`${part}-${index}`}>{part}</Fragment>
  })

const renderTextWithBreaks = (text) =>
  text.split('\n').map((line, index) => (
    <Fragment key={`${text}-${index}`}>
      {index > 0 ? <br /> : null}
      {renderInlineText(line)}
    </Fragment>
  ))

const DynamicBlogDetail = ({ post }) => (
  <main className={styles.page}>
    <article className={styles.article}>
      <div className={styles.titleWrap}>
        <h1 style={{color: '#6459D9'}}>{post.tag}</h1>
        <DisplayText fullText={post.title}/>
      </div>

      <div className={styles.authors}>
        <div className={styles.authorAvatars}>
          {post.authors.map((author, index) => (
            <img
              key={author.name}
              src={author.avatar}
              alt={author.name}
              style={{ position: 'relative', zIndex: post.authors.length - index }}
            />
          ))}
        </div>
        <p>{post.authors.map((author) => author.name).join(', ')}</p>
      </div>

      <img className={styles.hero} src={post.detailHeroImage || post.image} alt={post.title} />

      {post.detailSections.map((section, index) => (
        <Fragment key={`${post.slug}-${section.heading || index}`}>
          <section className={`${styles.content} ${index === 0 ? styles.firstContent : ''}`}>
            {section.heading ? <h2>{section.heading}</h2> : null}
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph}>{renderTextWithBreaks(paragraph)}</p>
            ))}
            {section.linkName ? <Link to={section.link}>{section.linkName}</Link> : null}
            {section.points?.length ? (
              <div className="mb-[24px]">
                {section.points.map((point) => (
                  <div key={point} className="flex items-start mb-[8px]">
                    <span className={styles.listDot} />
                    <p className="flex-1">{renderTextWithBreaks(point)}</p>
                  </div>
                ))}
              </div>
            ) : null}
            {section.tailParagraphs?.map((paragraph) => (
              <p key={paragraph}>{renderTextWithBreaks(paragraph)}</p>
            ))}
          </section>
          {(section.figures || (section.figure ? [section.figure] : [])).map((figure) => (
            <FigureBlock
              key={`${post.slug}-${figure.alt}-${figure.caption}`}
              src={figure.src}
              alt={figure.alt}
              caption={figure.caption}
            />
          ))}
        </Fragment>
      ))}

      {/*<section className={styles.content}>*/}
      {/*  <p>*/}
      {/*    <Link to="/blog">Back to blog</Link>*/}
      {/*  </p>*/}
      {/*  {post.sourceUrl ? (*/}
      {/*    <p>*/}
      {/*      <a href={post.sourceUrl} target="_blank" rel="noreferrer">{post.sourceLabel || 'Read the original article on Medium'}</a>*/}
      {/*    </p>*/}
      {/*  ) : null}*/}
      {/*</section>*/}
    </article>
  </main>
)

const BlogDetail2 = () => {
  const [searchParams] = useSearchParams()
  const slug = searchParams.get('slug') || 'execution-verification'
  const selectedPost = useMemo(() => getPostBySlug(slug), [slug])

  useEffect(() => {
    scrollToPageTop()
  }, [slug])

  return selectedPost ? <DynamicBlogDetail post={selectedPost} /> : null
}

export default BlogDetail2
